import styled from 'styled-components'
import { Button, Box, Tooltip } from '@mui/material'
import { LocalizationProvider, MobileDateTimePicker } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { StepsHeader } from '../../../components'
import { useTranslation } from "react-i18next"

const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 32px;

  > span + span {
    margin-bottom: 24px;
  }
`

const Footer = styled(Box)`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
`

const twentyFourhours = 1000 * 60 * 60 * 24
const fourtyEightHours = twentyFourhours * 2
const dateNow = new Date()

const IntakeCaffeineTime = ({
  caffeineTime,
  setCaffeineTime,
  step,
  onNext,
  onPrevious,
}) => {
  const { t } = useTranslation('common')
  const minDate = new Date(dateNow.getTime() - fourtyEightHours)
  const maxDate = new Date(dateNow.getTime() + twentyFourhours) 
  return (
    <Container>
      <div>
        <StepsHeader
          stepText={step}
          description={t('caffeine.time.description')}
        />

        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <ContentContainer>
            <span
              style={{ fontSize: 24, fontWeight: 700, textAlign: 'center' }}
            >
              {t('caffeine.time.question')}
            </span>
            <span style={{ fontSize: 18, textAlign: 'center' }}>
              {t('caffeine.time.input_request')}
            </span>
            <MobileDateTimePicker
              label={t('caffeine.time.time_picker')}
              ampm={false}
              minutesStep={15}
              value={caffeineTime}
              onChange={newValue => setCaffeineTime(newValue)}
              minDate={minDate}
              maxDate={maxDate}
              views={['day', 'hours', 'minutes']}
              openTo='hours'
              orientation='landscape'
              format='dd/MM - HH:mm'
            />
          </ContentContainer>
        </LocalizationProvider>
      </div>
      <Footer>
        <Button
          variant='text'
          onClick={onPrevious}
          startIcon={<ArrowBackIcon />}
        >
          {t('caffeine.time.return')}
        </Button>
        {!caffeineTime ? (
          <Tooltip
            title='Selecione um horário para continuar'
            placement='top'
            arrow
          >
            <span>
              <Button
                variant='contained'
                disabled
              >
                {t('caffeine.time.finish')}
              </Button>
            </span>
          </Tooltip>
        ) : (
          <Button
            variant='contained'
            onClick={onNext}
          >
            {t('caffeine.time.finish')}
          </Button>
        )}
      </Footer>
    </Container>
  )
}

export default IntakeCaffeineTime
